export const formatUrlBasedAnonymousID = ({
  switchUrl,
  redirectAnonymousID,
  anonymousId,
}) => {
  return !!redirectAnonymousID
    ? `${switchUrl}&${redirectAnonymousID}=${anonymousId}`
    : switchUrl
}
